"use strict";

export const initWiseMetricsTabs = async () => {
    const selects = document.querySelectorAll('.wise-metrics__select');
    
    if (!selects.length) return;

    // Import Bootstrap Tab
    const TabModule = await import('bootstrap/js/dist/tab');
    const Tab = TabModule.default;

    selects.forEach(select => {
        // Listen to both regular change and select2:select events
        select.addEventListener('change', function() {
            const targetId = this.value;
            const tabTrigger = document.querySelector(`[data-bs-target="#${targetId}"]`);
            
            if (tabTrigger) {
                // Trigger Bootstrap tab
                const tab = Tab.getOrCreateInstance(tabTrigger);
                tab.show();
            }
        });

        // Listen to select2:select event for Select2 compatibility
        $(select).on('select2:select', function(e) {
            const targetId = e.params.data.id;
            const tabTrigger = document.querySelector(`[data-bs-target="#${targetId}"]`);
            
            if (tabTrigger) {
                // Trigger Bootstrap tab
                const tab = Tab.getOrCreateInstance(tabTrigger);
                tab.show();
            }
        });
    });

    // Update select when tab changes (for accessibility)
    const tabButtons = document.querySelectorAll('[data-bs-toggle="tab"]');
    tabButtons.forEach(button => {
        button.addEventListener('shown.bs.tab', function(event) {
            const targetId = event.target.getAttribute('data-bs-target').replace('#', '');
            const relatedSelect = document.querySelector(`.wise-metrics__select option[value="${targetId}"]`);
            
            if (relatedSelect) {
                const selectElement = relatedSelect.parentElement;
                selectElement.value = targetId;
                // Trigger select2 update if it's initialized
                if ($(selectElement).hasClass('select2-hidden-accessible')) {
                    $(selectElement).trigger('change.select2');
                }
            }
        });
    });
};
